import { render } from "./DraggableContainer.vue?vue&type=template&id=2fb1486c&scoped=true"
import script from "./DraggableContainer.vue?vue&type=script&lang=js"
export * from "./DraggableContainer.vue?vue&type=script&lang=js"

import "./DraggableContainer.vue?vue&type=style&index=0&id=2fb1486c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fb1486c"

export default script